var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QrCode"},[_c('el-card',{staticClass:"box-card"},[_c('img',{attrs:{"src":require("@/assets/qrcode/qrcode.png"),"alt":"","width":"300px","height":"300px"}}),_vm._v(" "),_c('div',[_vm._v("请扫码参与活动")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac4857dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QrCode/QrCode.vue
// module id = null
// module chunks = 